<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="1100px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onAbort"
        @click:outside="onAbort"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Historia przypisań
                </h1>
            </v-card-title>

            <v-card-text>
                <v-data-table
                    :headers="requestAssignHeaders"
                    :items="requestAssignHistory"
                    hide-default-footer
                    disable-pagination
                    fixed-header
                    :mobile-breakpoint="0"
                    name="requestsAssignData"
                >
                    <template #item="{item}">
                        <tr>
                            <td>
                                <template v-if="item.createdBy.firstName && item.createdBy.lastName">
                                    {{ item.createdBy.firstName }} {{ item.createdBy.lastName }}
                                </template>
                                <template v-else>
                                    {{ item.createdBy.username }}
                                </template>
                            </td>
                            <td>
                                <template v-if="item.assignedTo.firstName && item.assignedTo.lastName">
                                    {{ item.assignedTo.firstName }} {{ item.assignedTo.lastName }}
                                </template>
                                <template v-else>
                                    {{ item.assignedTo.username }}
                                </template>
                            </td>
                            <td>
                                {{ formatDate(item.createdAt) }}
                            </td>
                        </tr>
                    </template>
                    <template slot="no-results" :value="true">
                        <p class="text-center">
                            Brak danych
                        </p>
                    </template>
                </v-data-table>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onAbort"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'

export default {
    name: 'AssignHistoryDialog',
    mixins: [
        dateFormatter,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        requestAssignHistory: {
            type: Array,
            default: null
        },
    },
    data() {
        return {
            requestAssignHeaders: [
                {
                    text: 'Zgłaszający',
                    sortable: false,
                    value: 'createdBy'
                },
                {
                    text: 'Przypisany',
                    sortable: false,
                    value: 'assignedTo'
                },
                {
                    text: 'Data utworzenia',
                    sortable: false,
                    value: 'createdAt'
                }
            ]
        }
    },
    methods: {
        onAbort() {
            this.$emit('close-assign-history-dialog')
        },
    }
}
</script>